<div class="clients-modal">

  <!-- Header -->
  <div class="row align-items-center">
    <div class="col">
      <h3 class="text-manax m-0 mb-4 d-flex justify-content-between align-items-center">
        <span class="text-purple-manax text-capitalize title-modal">
          Cliente
        </span>
        <span class="d-flex align-items-center">
          <button type="button" class="btn btn-link text-manax mr-4 p-2" (click)="openMovementsModal()"
            *ngIf="client?._id && !toBilling">
            <i class="material-icons">access_time</i> Fichajes
          </button>
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
      </h3>
    </div>
  </div>


  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 client-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-md-3 pt-2">

            <div class="row">
              <div class="col-12 pb-1">
                <mat-form-field appearance="outline">
                  <mat-label> Tipo de Cliente </mat-label>
                  <mat-select name="clientType" formControlName="clientType" [disabled]="readOnly">
                    <mat-option value="PERSON">{{clientTypes.PERSON}}</mat-option>
                    <mat-option value="COMPANY">{{clientTypes.COMPANY}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="submitted && f['clientType']?.errors?.['required']">
                  Tipo de cliente Obligatorio
                </mat-error>
              </div>

              <div class="col-12 pb-1" *ngIf="f['clientType']?.value == 'PERSON'">
                <mat-form-field appearance="outline">
                  <mat-label> Nombre </mat-label>
                  <input matInput name="firstname" formControlName="firstname" type="text" #firstnameInput
                    [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['firstname'].errors }">
                </mat-form-field>
                <mat-error *ngIf="submitted && f['firstname']?.errors?.['required']">
                  Nombre Obligatorio
                </mat-error>
                <mat-error *ngIf="submitted && f['firstname']?.errors?.['nameBillingRequired']">
                  Nombre Obligatorio para facturar
                </mat-error>
              </div>

              <div class="col-12 pb-1" *ngIf="f['clientType']?.value == 'PERSON'">
                <mat-form-field appearance="outline">
                  <mat-label> Apellido </mat-label>
                  <input matInput name="lastname" formControlName="lastname" type="text" #lastnameInput
                    [readonly]="readOnly">
                </mat-form-field>
              </div>

              <div class="col-12 pb-1" *ngIf="f['clientType']?.value == 'COMPANY'">
                <mat-form-field appearance="outline">
                  <mat-label> Denominación Social </mat-label>
                  <input matInput name="corporatename" formControlName="corporatename" type="text" #corporatenameInput
                    [readonly]="readOnly" required>
                </mat-form-field>
                <mat-error *ngIf="submitted && f['corporatename']?.errors?.['required']">
                  Denominación Social Obligatoria
                </mat-error>
              </div>

              <div class="col-12 pb-1">
                <mat-form-field appearance="outline">
                  <mat-label> Número de Identificación Fiscal </mat-label>
                  <input matInput name="nit" formControlName="nit" type="text" #nitInput [readonly]="readOnly">
                </mat-form-field>
                <mat-error *ngIf="submitted && f['nit']?.errors?.['nitBillingRequired']">
                  NIF Obligatorio para facturar
                </mat-error>
              </div>

              <div class="col-12 pb-1">
                <mat-form-field appearance="outline">
                  <mat-label> Dirección fiscal </mat-label>
                  <input matInput name="taxAddress" formControlName="taxAddress" type="text" #taxaddressInput
                    [readonly]="readOnly">
                </mat-form-field>
                <mat-error *ngIf="submitted && f['taxAddress']?.errors?.['tABillingRequired']">
                  Dirección fiscal Obligatoria para facturar
                </mat-error>
              </div>

            </div>
          </div>

          <div class="col-md-9 bg-light p-1">
            <div class="row">

              <!-- phones -->
              <div class="col-md-6" *ngIf="f['clientType']?.value == 'PERSON'">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div>
                      <span class="contact-group">Teléfonos</span>
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                        (click)="addPhone()">
                        <i class="material-icons small">add</i> agregar
                      </button>
                    </div>
                    <div *ngIf="!phones.controls?.length"> - sin teléfonos - </div>
                  </div>
                </div>
                <ng-container *ngFor="let p of phones.controls; let i=index">
                  <div formArrayName="phones">
                    <div [formGroupName]="i">

                      <div class="row">
                        <div class="col-md-10">
                          <mat-form-field appearance="outline">
                            <mat-label> {{ 'Número ' + (i + 1) }} </mat-label>
                            <input matInput [readonly]="readOnly" type="number" name="number" formControlName="number">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2 pl-md-0">
                          <button *ngIf="!readOnly" type="button"
                            class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small" (click)="removePhone(i)">quitar
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- emails -->
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div>
                      <span class="contact-group">Correos electrónicos</span>
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                        (click)="addEmail()">
                        <i class="material-icons small">add</i> agregar
                      </button>
                    </div>
                    <div *ngIf="!emails.controls?.length"> - sin correos - </div>
                  </div>
                </div>
                <ng-container *ngFor="let p of emails.controls; let i=index">
                  <div formArrayName="emails">
                    <div [formGroupName]="i">

                      <div class="row">
                        <div class="col-md-10">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Email ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="address" formControlName="address">
                          </mat-form-field>
                        </div>

                        <div class="col-md-2 pl-md-0">
                          <button *ngIf="!readOnly" type="button"
                            class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small" (click)="removeEmail(i)">quitar
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- contacts -->
              <div class="col-md-12" *ngIf="f['clientType']?.value == 'COMPANY'">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div>
                      <span class="contact-group">Contactos</span>
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                        (click)="addContact()">
                        <i class="material-icons small">add</i> agregar
                      </button>
                    </div>
                    <div *ngIf="!contacts.controls?.length"> - sin contactos - </div>
                  </div>
                </div>
                <ng-container *ngFor="let p of contacts.controls; let i=index">
                  <div formArrayName="clientContacts">
                    <div [formGroupName]="i">

                      <div class="row pb-1">
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Nombre ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="firstname"
                              formControlName="firstname" required>
                          </mat-form-field>
                          <mat-error *ngIf="submitted && getContactGroup(i).get('firstname')?.errors?.['required']">
                            Nombre Obligatorio
                          </mat-error>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Apellido ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="lastname"
                              formControlName="lastname">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Puesto ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="position"
                              formControlName="position">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Teléfono ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="phone" formControlName="phone">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Email ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="email" formControlName="email">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2 pl-md-0">
                          <button *ngIf="!readOnly" type="button"
                            class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small" (click)="removeContact(i)">quitar
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- address -->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div>
                      <span class="contact-group">Direcciones / Domicilios</span>
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                        (click)="addAddress()">
                        <i class="material-icons small">add</i> agregar
                      </button>
                    </div>
                    <div *ngIf="!addresses.controls?.length"> - sin direcciones - </div>
                  </div>
                </div>
                <ng-container *ngFor="let p of addresses.controls; let i=index">
                  <div formArrayName="addresses">
                    <div [formGroupName]="i">

                      <div class="row">
                        <div class="col-md-10 field-container">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Dirección ' + (i + 1) }}</mat-label>
                            <input matInput name="address" formControlName="address" type="text" [readonly]="true"
                              (click)="openGetLocationModal(i)" class="cursor-pointer">
                          </mat-form-field>

                          <span class="field-actions">
                            <button type="button" class="btn btn-link text-manax p-0 m-0 btn-new-input"
                              (click)="openGetLocationModal(i)">
                              <i class="material-icons">place</i>
                            </button>
                          </span>
                        </div>

                        <div class="col-md-2 pl-md-0">
                          <button *ngIf="!readOnly" type="button"
                            class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small" (click)="removeAddress(i)">quitar
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <!--div class="row mt-3" *ngIf="client._id && isDev">
          <div class="col-2">
            <label>
              Borrada? <br>
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" disabled *ngIf="readOnly">
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" *ngIf="!readOnly">
            </label>
          </div>
          <div class="col-4">
            <mat-form-field appearance="outline" >
              <input matInput placeholder="Id" type="text" [value]="client._id" readonly>
            </mat-form-field>
          </div>
        </div-->
        <div class="row">
          <div class="col-12 pt-4">
            <!--button mat-raised-button type="button" class="m-0 ml-1 mb-2 pull-left btn btn-light"
              (click)="openMovementsModal()" *ngIf="client?._id">
              Marcaciones
            </button-->

            <!--button mat-raised-button type="button" class="m-0 ml-1 mb-2 pull-left btn btn-light"
              (click)="openShareTasksConfirm()" *ngIf="client?._id && isDev">
              Test Compartir
            </button-->

            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax"
              *ngIf="!readOnly">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link" (click)="cancelSubmit(); "
              *ngIf="!readOnly">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>